import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../_components/Header';
import SearchBar from './Search';
import Spinner from '../_components/Spinner';
import { BusinessProfileActions } from '../_actions';
import NoResults from '../_components/NoResults';

function Companies() {
  const dispatch = useDispatch();
  const { companies, isLoading } = useSelector((state) => state.jobsForm);

  function renderJobs() {
    if (!companies?.length) {
      return (
        <div className="col-md-12 ">
          <NoResults />
        </div>
      );
    }
    return companies.map((job) => (
      <div key={job.id} className="col-md-3">
        <Link to={'/companies/' + job.id}>
          <div className="recommend-box company  clear text-center">
            <img src={job.logo} alt={job.business_name} />
            <div>
              <h3 className="marginless job-name">{job.business_name}</h3>
              <div className="description">{job.activity}</div>
              <div className="vacancies">
                {' '}
                {job.vacancies} {job.vacancies === 1 ? 'vacante' : 'vacantes'}{' '}
                activas
              </div>
            </div>
          </div>
        </Link>
      </div>
    ));
  }

  return (
    <div className="companies-home">
      <Header />
      <div className="container">
        <div className="offset-md-1 col-md-10">
          <SearchBar
            search={(text) =>
              dispatch(BusinessProfileActions.GetCompanies(text))
            }
          />

          <div className="jobs-title-container">
            <span className="jobs-subtitle">Listado de compañías</span>

            {/* <span onClick={this.handleShow} className="float-right pointer filters-text">
                                Filtros
                                <img src={filterIcon} alt="" />
                            </span> */}
          </div>

          <div className="row recommend">
            {isLoading ? <Spinner /> : renderJobs()}
          </div>
        </div>
      </div>
    </div>
  );
}

export { Companies };
